/** Align with events calendar: only explicit inactive values count as inactive. */
export function normalizeEventIsActive(value: unknown): boolean {
  if (value === undefined || value === null) {
    return true;
  }
  if (typeof value === 'boolean') {
    return value;
  }
  if (typeof value === 'number') {
    return value !== 0;
  }
  if (typeof value === 'string') {
    const v = value.trim().toLowerCase();
    if (v === '0' || v === 'false' || v === 'no' || v === 'off') {
      return false;
    }
    if (v === '' || v === '1' || v === 'true' || v === 'yes' || v === 'on') {
      return true;
    }
  }
  return Boolean(value);
}

export function normalizeEventIsShown(value: unknown): boolean {
  return normalizeEventIsActive(value);
}
